import {ActionTypes, CCAuthorizedAxios, DataActionTypes, CCAxios} from './../../cc-imports'

const Actions = {
    createEntry: (entry, authDetails)=> {
        return {
            type: ActionTypes.CREATE_ENTRY,
            payload: CCAuthorizedAxios(authDetails).post('/entry', entry),
            meta:{
                type : DataActionTypes.CREATE
            }
        }
    },
    getEntriesByLeagueId: (req, authDetails, type, leagueId) => {
        return {
            type: ActionTypes.GET_ENTRIES,
            payload: CCAuthorizedAxios(authDetails).get('/entry/leagueId/' + req.leagueId + '/skip/' + req.skip + '/limit/' + req.limit + '/'),
            meta : {
                type : type,
                id : leagueId
            }
        }
    },

    getEntriesByUserId: (userId, skip, limit , type) => {
        return {
            type: ActionTypes.GET_ENTRIES,
            payload: CCAxios.get('/entry/userId/' + userId + '/skip/' + skip + '/limit/' + limit + '/'),
            meta : {
                type : type,
                id : userId
            }
        }
    },

    /*getEntriesByUserId: (req, authDetails, type) => {
        return {
            type: ActionTypes.GET_ENTRIES,
            payload: CCAuthorizedAxios(authDetails).get('/entry/userId/' + req.userID + '/skip/' + req.skip + '/limit/' + req.limit + '/'),
            meta : {
                type : type
            }
        }
    },*/

    getEntriesByUserIdAndLeagueId: (req, authDetails, type) => {
        return {
            type: ActionTypes.GET_ENTRIES,
            payload: CCAuthorizedAxios(authDetails).get('/entry/leagueId/' + req.leagueId + '/userId/' + req.userId+'/'),
            meta : {
                type : type
            }
        }
    },

    getEntriesByUserIdAndMatchId: (req, authDetails, type) => {
        return {
            type: ActionTypes.GET_ENTRIES,
            payload: CCAuthorizedAxios(authDetails).get('/entry/matchId/' + req.matchId + '/userId/' + req.userId+'/'),
            meta : {
                type : type
            }
        }
    },

    getLiveEntriesByUserId: (accessToken, userId, type) => {
        return {
            type: ActionTypes.GET_ENTRIES,
            payload: CCAuthorizedAxios({accessToken}).get('/entry/userId/' + userId + '/live/'),
            meta : {
                type : type,
                id : userId
            }
        }
    },

    entryUpdated: (entry, id)=>{
        return {
            type: ActionTypes.ENTRY_UPDATED,
            payload: entry,
            meta : {
                type : DataActionTypes.UPDATE,
                id : id
            }
        }
    }

    /*getLiveEntriesByUserId: (req, authDetails, type) => {
        return {
            type: ActionTypes.GET_ENTRIES,
            payload: CCAuthorizedAxios(authDetails).get('/entry/userId/' + req.userID + '/live/'),
            meta : {
                type : type
            }
        }
    }*/
};

export default Actions



// WEBPACK FOOTER //
// ./src/app/data/actions/EntryActions.js